// src/features/message-queue/message-queue.slice.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import i18n from '../../i18n/i18n';
import { IGetJobsResponse, IMessageQueueState } from '../../interface';
import { fetchMessageQueueJobs } from '../action';

const initialState: IMessageQueueState = {
  jobs: [],
  totalRecords: 0,
  currentPage: 1,
  pageSize: 10,
  isLoading: false,
  error: null,
};

const messageQueueSlice = createSlice({
  name: 'message-queue',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMessageQueueJobs.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(
        fetchMessageQueueJobs.fulfilled,
        (state, action: PayloadAction<IGetJobsResponse>) => {
          state.isLoading = false;
          state.jobs = action.payload.data.jobs;
          state.totalRecords = action.payload.data.total;
          state.currentPage = action.payload.data.currentPage;
          state.pageSize = action.payload.data.pageSize;
        },
      )
      .addCase(fetchMessageQueueJobs.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload?.message || i18n.t('toast.failed_to_fetch_jobs', 'Failed to fetch jobs.');
        state.jobs = [];
      });
  },
});

export default messageQueueSlice.reducer;
